import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterMdfStatus = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.mdfStatus
)
